import { render, staticRenderFns } from "./B2CServicesList.vue?vue&type=template&id=3645ed3c&scoped=true&"
import script from "./B2CServicesList.vue?vue&type=script&lang=js&"
export * from "./B2CServicesList.vue?vue&type=script&lang=js&"
import style0 from "./B2CServicesList.vue?vue&type=style&index=0&id=3645ed3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3645ed3c",
  null
  
)

export default component.exports